import { useSearchParams } from "react-router-dom";
import AuthorizationForm from "../../ConsentForm/AuthorizationForm";
import PanCardForm from "../../CheckDetails/PanCard/PanCardForm";
import FirstEducationForm from "../../CheckDetails/EducationValidation/FirstEducationForm";
import PersonalInfoForm from "../../PersonalDetails/PersonalInfoForm";
import AadharValidateForm from "../../CheckDetails/AadharValidation/AadharValidateForm";
import SecondEducationForm from "../../CheckDetails/EducationValidation/SecondEducationForm";
import EmployementForm1 from "../../CheckDetails/EmploymentValidation/EmployementForm1";
import EmployementHistory from "../../CheckDetails/EmploymentValidation/EmployementHistory";
import LastTwoEducationForm from "../../CheckDetails/EducationValidation/LastTwoEducationForm";
import PanCardWithoutValid from "../../CheckDetails/PanCard/PanCardWithoutValid";
import CareerGap from "../../CheckDetails/CareerGap/CareerGapForm";
import EducationDocuments from "../../CheckDetails/EducationDocument/EducationDocuments";
import Reference from "../../CheckDetails/Reference/Reference";

const SuperAdminDashboard = () => {
  const [searchParams] = useSearchParams();

  const module = searchParams.get("module");

  const renderComponent = () => {
    switch (module) {
      case "adharvalidation":
        return <AadharValidateForm />;

      case "firstEducationForm":
        return <FirstEducationForm />;

      case "secondEducationForm":
        return <SecondEducationForm />;

      case "lastTwoEducation":
        return <LastTwoEducationForm />;

      case "educationDocuments":
        return <EducationDocuments />;

      case "employeeForm":
        return <EmployementForm1 />;

      case "employmentHistory":
        return <EmployementHistory />;

      case "pancardForm":
        return <PanCardForm />;

      case "pancardWithoutValidation":
        return <PanCardWithoutValid />;

      case "authorization":
        return <AuthorizationForm />;

      case "careerGapComments":
        return <CareerGap />;

      case "reference":
        return <Reference />;

      default:
        return <PersonalInfoForm />;
    }
  };

  return <div key={module}>{renderComponent()}</div>;
};

export default SuperAdminDashboard;
